<template>
  <div class="tablechart">
    <div class="table-wrap">
      <table class="table">
        <tr>
          <th
            v-for="headerKey in headerNames"
            @click="changeSorting(headerKey)"
            :class="{ isSelected: (currentSorting === headerKey) }"
            :style="{ 'cursor': isSortable(headerKey) ? 'pointer' : '' }"
          >
            <div class="rowheader">
              <ToggleArrow class="rowheader__arrow" v-if="isSortable(headerKey)" :closed="(currentSorting === headerKey && currentSortingOrder === 'asc')"></ToggleArrow>
            <div class="rowheader__key">{{ getHeaderName(headerKey) }}</div>
          </div>
        </th>
        </tr>
        <tr>
        </tr>
        <tr v-for="row in rows">
          <td
            v-for="key in headerNames"
            v-if="row[key]"
          >
            <span v-if="key !== 'ID_country_name' && key !== 'ID_year'">{{ getFixedValue(row[key]) }}</span>
            <span v-else>{{ row[key] }}</span>
          </td>
          <td v-else><em>N/A</em></td>
        </tr>
      </table>
      <table class="table"v-if="rows.length === 0">
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ToggleArrow from '../navigation/shared/ToggleArrow.vue'

export default {
  name: 'TableChart',
  components: { ToggleArrow },
  props: {
    data: {
      type: Array,
      required: true
    },
    showConfidenceInterval: {
      default: true,
      type: Boolean
    },
    sortingKey: {
      default: 'ID_country_name',
      type: String
    },
    showAttributes: {
      default () { return [] },
      type: Array
    }
  },
  computed: {
    headerNames () {
      let headers = ['ID_year', 'ID_country_name']
      let attributes = this.showAttributes

      if (!this.data[0]) return []
      _.each(this.data[0], (data, key) => {
        // Only take the headers matching the users
        // selected attributes
        if (
          (attributes.indexOf(key) !== -1 || this.showAll) &&
          !(key === 'ID_year' || key === 'ID_country_name')
        ) {
          if (this.headerExists(key)) { headers.push(key) }

          if (this.showConfidenceInterval) {
            if (this.headerExists(key + '_U')) { headers.push(key + '_U') }
            if (this.headerExists(key + '_L')) { headers.push(key + '_L') }
          }
        }
      })
      return headers
    },
    rows () {
      let result = _.filter(this.data, _.size)
      let rows = _.sortBy(result, (row) => {
        return row[this.currentSorting]
      })
      if (this.currentSortingOrder === 'desc') {
        return rows.reverse()
      } else {
        return rows
      }
    }
  },
  data () {
    return {
      currentSorting: this.sortingKey,
      currentSortingOrder: 'asc'
    }
  },
  methods: {
    isSortable (headerKey) {
      if (!headerKey) { return false }
      if (['ID_country_name', 'ID_year'].indexOf(headerKey) !== -1) return true
    },
    changeSorting (headerKey) {
      if (this.isSortable(headerKey)) {
        if (this.currentSorting === headerKey) {
          this.currentSortingOrder = (this.currentSortingOrder === 'asc') ? 'desc' : 'asc'
        } else {
          this.currentSorting = headerKey
          this.currentSortingOrder = 'asc'
        }
      }
    },
    headerExists (key) {
      return !!(this.getHeaderName(key))
    },
    getHeaderName (key) {
      let name
      if (key === 'ID_year') return 'Year'
      if (key === 'ID_country_name') return 'Country name'

      if (key.slice(-2) === '_U') {
        name = this.$store.getters['attributes/labelInfo'](key.slice(0, (key.length - 2)), 'name')
        return name ? name + ' Confidence Interval Upper Limit' : false
      }

      if (key.slice(-2) === '_L') {
        name = this.$store.getters['attributes/labelInfo'](key.slice(0, (key.length - 2)), 'name')
        return name ? name + ' Confidence Interval Lower Limit' : false
      }

      return this.$store.getters['attributes/labelInfo'](key, 'name') + ' Score'
    },
    setSort (selectedSort) {
      this.sortBy = selectedSort
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/placeholders/tooltip';

  .tablechart{
    min-height: 300px;
    position: relative;
    text-align: left;
  }

  .table-wrap{
    max-width: 100%;
    overflow-x: auto;
  }
  // .table-wrap:after {
  //   display: block;
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   bottom: 0;
  //   right: 0;
  //   width: 100px;
  //   background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 75%,rgba(255,255,255,1) 100%);
  //   z-index: 1;
  // }

  .table{
    border-collapse: collapse;
    text-align: left;
    margin-top: 20px;
    min-width: calc(100% - 2px); // - 2px border
    width: auto;

    TH,
    TD{
      padding: 0.5em 1em;
      margin: 0;
    }

    TD{ border: 1px solid $gray-lighter; }
  }

  .isSelected{
    text-decoration: underline;
  }

  .rowheader{
    text-align: center;
  }
  .rowheader__arrow{
  }
  .rowheader__key{
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/charts/TableChart.vue